module.exports = __webpack_public_path__ + "img/brief-icon-black-white.d81c32f2.png";